import { render, staticRenderFns } from "./OfertsHotelByOne.vue?vue&type=template&id=5d845a74&scoped=true&"
import script from "./OfertsHotelByOne.vue?vue&type=script&lang=js&"
export * from "./OfertsHotelByOne.vue?vue&type=script&lang=js&"
import style0 from "./OfertsHotelByOne.vue?vue&type=style&index=0&id=5d845a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d845a74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VListItem,VListItemTitle,VRow,VSelect,VTooltip})
